import styled, { css } from "styled-components";
import { FlatContentRow } from "components/common";
export const SEARCH_BAR_GAP = "10px";
export const SEARCH_BAR_CONTAINER_NAME = "search-bar";
export const searchBarContainerStyles = css`
  container: ${SEARCH_BAR_CONTAINER_NAME} / inline-size;
  display: flex;
  flex-direction: column;
  gap: ${SEARCH_BAR_GAP};
`;
export const SearchBarContainer = styled(FlatContentRow)`
  ${searchBarContainerStyles}
`;
export const SearchQueryRow = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${SEARCH_BAR_GAP};
    align-items: flex-start;

    @container ${SEARCH_BAR_CONTAINER_NAME} (max-width: ${theme.breakpoints.max.sm}) {
      flex-direction: column;

      > div {
        width: 100%;
      }
    }
  `
);
export const SearchButtonAndQuery = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  gap: ${SEARCH_BAR_GAP};
`;
export const SearchInputAndValidationContainer = styled.div`
  display: flex;
  flex: 1;
`;
export const TimeRangeRow = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${SEARCH_BAR_GAP};
    align-items: flex-start;

    @container ${SEARCH_BAR_CONTAINER_NAME} (max-width: ${theme.breakpoints.max.md}) {
      flex-direction: column;

      > div {
        width: 100%;
      }
    }
  `
);
